module.exports = __webpack_public_path__ + "img/heste1.217fae1d.jpg";